// TODO: clean up cases.
// landing should be camelCase.
const allModules = [
  {
    name: 'locationID',
    displayName: 'Location ID',
    landing: 'locationID',
    permission: 'LOCID:APP:NAV:VIEW',
    spec: '',
  },
  {
    name: 'directMatch',
    displayName: 'DirectMatch',
    landing: 'directMatch',
    permission: 'DRMCH:APP:NAV:VIEW',
    spec: 'DIRECTMATCH',
  },
  {
    name: 'personId',
    displayName: 'Person ID',
    landing: 'personId',
    permission: 'PRSID:APP:NAV:VIEW',
    spec: 'ASSIGN',
  },
];

export function findModule(name) {
  const module = allModules.filter(m => m.name === name)[0];
  if (module !== null) {
    return module;
  }

  return null;
}

export default {
  namespaced: true,
  state: {
    activeModule: null,
    allModules,
  },
  mutations: {
    SET_MODULE: (state, activeModule) => {
      state.activeModule = activeModule;
    },
  },
  actions: {
    SETMODULE: (store, activeModule) => {
      store.commit('SET_MODULE', activeModule);
    },
  },
  getters: {
    getActiveModule: state => state.activeModule,
    activeModules: (state, getters, rootState) => allModules.filter(
      module => rootState.user.permissions.includes(module.permission),
    ),
    getAllModules: state => state.allModules,
  },
};
